import React from "react"

export const Switcher = props => {
    return <select onChange={props.changeKey} className="switcher">
        {props.projects.map((project, index) => {
            return <option key={project.name} value={index}>{project.name}</option>
        })}
    </select>
}